<script setup lang="ts">
import RadioButtonController from '@/components/RadioButtonController/RadioButtonController.vue'
import { useRodoStore } from '@/domains/rodo/store/useRodoStore'
import { useHasProduct } from '@/domains/rodo/composables/useHasProduct'

const { hasProducts } = useHasProduct()

const { step, isUsingProduct } = useRodoStore()

const setIsUsingProduct = (event: boolean) => {
  isUsingProduct.value = event
  step.value++
}
</script>

<template>
  <RadioButtonController
    :model-value="isUsingProduct"
    :radio-controls="hasProducts"
    @update="setIsUsingProduct"
  />
</template>
